import { shouldShowUnregisteredIdle } from '@/helpers/shouldShowUnregisteredIdle'

export interface BootSplashDismissInputs {
  showQuotaExceededScreen: boolean
  tenant: { quotaExcess?: boolean } | null
  registrationCode: string | null
  pairingAfterUnregisterPending: boolean
  /** True once the first on-screen playback pixels have painted (hybrid: Media3 first frame). */
  firstPlaybackFramePainted: boolean
  /** Elapsed ms since the boot cover started waiting on a registered tenant. */
  coverElapsedMs: number
  /** Last-resort wait before revealing the unified loading scene under the splash. */
  coverMaxMs: number
}

/**
 * Vue applying a hybrid video surface is not paint — Media3 `onFirstFrame` is.
 * Images / web video can mark paint when the surface commits.
 */
export function shouldMarkBootPaintFromSurfaceApply(nativeHybridVideoOnAir: boolean): boolean {
  return !nativeHybridVideoOnAir
}

/**
 * Keeps the HTML boot splash (`#app-loading`) until:
 * - operator action is required (quota / pairing QR), or
 * - the first playback frame has painted, or
 * - a registered player has waited past {@link BootSplashDismissInputs.coverMaxMs}
 *   (last resort if paint never arrives).
 */
export function resolveShouldDismissBootSplash(input: BootSplashDismissInputs): boolean {
  if (input.showQuotaExceededScreen) {
    return true
  }
  if (
    shouldShowUnregisteredIdle({
      tenant: input.tenant,
      registrationCode: input.registrationCode,
      pairingAfterUnregisterPending: input.pairingAfterUnregisterPending
    })
  ) {
    return true
  }
  const tenant = input.tenant
  if (tenant == null || tenant.quotaExcess === true) {
    return false
  }
  if (input.firstPlaybackFramePainted) {
    return true
  }
  return input.coverElapsedMs >= input.coverMaxMs
}
